<div class="p-6">
  <div class="flex items-center justify-between mb-4">
    <h3 class="text-lg font-bold text-primaryDark" i18n>Izberite paket</h3>
    <button type="button" class="btn border-transparent shadow-none text-gray hover:text-grayDark" (click)="cancel()">
      <i class="fas fa-times text-lg"></i>
    </button>
  </div>
  <div class="grid grid-cols-1 gap-4">
    <div *ngFor="let pkg of data.packages"
         class="border rounded-lg p-4 flex flex-col gap-2"
         [class.border-primary]="!isCurrent(pkg)"
         [class.border-gray-200]="isCurrent(pkg)">
      <div class="flex items-center justify-between">
        <span class="font-bold text-primaryDark">{{ pkg.name }}</span>
        <span *ngIf="isCurrent(pkg)" class="text-xs font-semibold rounded-full px-2 py-1 bg-pillGrayBg text-pillGrayText whitespace-nowrap" i18n>Aktivno</span>
      </div>
      <p class="text-xs text-gray-500" *ngIf="pkg.description">{{ pkg.description }}</p>
      <div class="text-sm text-gray-700">
        <span *ngIf="pkg.priceMonthly != null">{{ pkg.priceMonthly | number:'1.2-2' }} €<span i18n>/mesec</span></span>
        <span *ngIf="pkg.priceYearly != null" class="block text-xs text-gray-400">
          {{ pkg.priceYearly | number:'1.2-2' }} €<span i18n>/leto</span>
          <span *ngIf="pkg.yearlyDiscountPct">&nbsp;(&minus;{{ pkg.yearlyDiscountPct }}%)</span>
        </span>
      </div>
      <button type="button" class="btn btn-sm btn-primary mt-2" [disabled]="isCurrent(pkg)" (click)="selectPackage(pkg)">
        <span *ngIf="isCurrent(pkg)" i18n>Trenutni paket</span>
        <span *ngIf="!isCurrent(pkg)" i18n>Izberi</span>
      </button>
    </div>
  </div>
</div>
